export default "__VITE_ASSET__XlnDzsEX__"